import { render } from "./SettingsColorIcon.vue?vue&type=template&id=3edd46d2"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/SettingsColorIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3edd46d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3edd46d2', __exports__)) {
    api.reload('3edd46d2', __exports__)
  }
  
  module.hot.accept("./SettingsColorIcon.vue?vue&type=template&id=3edd46d2", () => {
    api.rerender('3edd46d2', render)
  })

}


export default __exports__